// Jerarquia de roles del frontend. Es el ESPEJO del backend (app/deps.py
// JERARQUIA); si allá cambia, aquí también. Vive en un solo lugar para que
// ninguna pantalla la redefina a mano y se vuelva a desincronizar (fue la
// causa del crash de la Fase 3: un mapa viejo de 3 roles en auth.jsx).
export const JERARQUIA = {
  CONSULTA: 1,
  OPERADOR: 2,
  ENCARGADO: 3,
  ADMIN: 4,
  DUENO: 5,
};

// ¿El rol cubre el nivel mínimo pedido? Un rol desconocido no cubre nada
// (0); un mínimo desconocido no lo cubre nadie (Infinity). Ambas fallas se
// resuelven negando el acceso, nunca reventando.
export function cumpleNivel(rol, minimo) {
  return (JERARQUIA[rol] || 0) >= (JERARQUIA[minimo] || Infinity);
}

// Etiqueta visible del rol (la escalera comercial de la Fase 5). Los CODIGOS
// del backend no cambian; aquí solo se traducen para el usuario.
export const ETIQUETA_ROL = {
  DUENO: 'Admin Supremo',
  ADMIN: 'Administrador',
  ENCARGADO: 'Encargado',
  OPERADOR: 'Operador',
  CONSULTA: 'Consulta',
};

export function etiquetaRol(rol) {
  return ETIQUETA_ROL[rol] || rol || '—';
}
